var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Scania')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'scania_default_menu',
        label: 'Default menu',
        disabled: false,
        description:
          'Set the default menu for the Scania dashboard skin. It is displayed when you use this dashboard.',
        values: _vm.fieldValues('scania_default_menu'),
        target: 'game'
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }